import { useCallback, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../store';
import {
  clearMutationError,
  fetchClienteTaxasThunk,
  setCurrentClienteId,
  updateClienteTaxasThunk,
} from '../store/slices/cliente-taxas.slice';
import { UpdateClienteTaxasPayload } from '../types/cliente-taxa';

export const useClienteTaxas = (clienteId: string | undefined) => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((s) => s.clienteTaxas);

  useEffect(() => {
    dispatch(setCurrentClienteId(clienteId ?? null));
  }, [dispatch, clienteId]);

  const refresh = useCallback(() => {
    if (!clienteId) return Promise.resolve(undefined);
    return dispatch(fetchClienteTaxasThunk(clienteId));
  }, [dispatch, clienteId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const update = useCallback(
    (payload: UpdateClienteTaxasPayload) => {
      if (!clienteId) return Promise.resolve(undefined);
      return dispatch(updateClienteTaxasThunk({ clienteId, payload }));
    },
    [dispatch, clienteId],
  );

  return {
    items: state.items,
    status: state.status,
    error: state.error,
    mutating: state.mutating,
    mutationError: state.mutationError,
    refresh,
    update,
    clearMutationError: () => dispatch(clearMutationError()),
  };
};
